import { useState } from 'react';
import { PersonasTab } from './PersonasTab';
import { RunsTab } from './RunsTab';
import { FindingsTab } from './FindingsTab';
import { DigestTab } from './DigestTab';
import './PersonaAgents.css';
import { TabStrip } from '@shared-ui/components';

type Tab = 'personas' | 'runs' | 'findings' | 'digest';

/** Tabbed host for the persona-agents observability area. */
export function PersonaAgents() {
  const [tab, setTab] = useState<Tab>('runs');
  return (
    <div className="settings-section">
      <div className="section-header">
        <h1>Persona Agents</h1>
        <p className="section-description">
          Synthetic-user sessions (dev-only): who the personas are, the runs they did, and the findings they produced.
        </p>
      </div>
      <TabStrip
        className="pa-tabs"
        ariaLabel="Persona agent views"
        active={tab}
        onChange={setTab}
        tabs={[
          { key: 'personas', label: 'Personas' },
          { key: 'runs', label: 'Agent Runs' },
          { key: 'findings', label: 'Findings' },
          { key: 'digest', label: 'Digest' },
        ] as const}
      />
      {tab === 'personas' && <PersonasTab />}
      {tab === 'runs' && <RunsTab />}
      {tab === 'findings' && <FindingsTab />}
      {tab === 'digest' && <DigestTab />}
    </div>
  );
}
